export default __webpack_public_path__ + "static/media/talking-points.a38eda72.jpg";